import { SignIn } from "auth";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const SignInPage: NextPage = () => {
	return (
		<>
			<NextSeo
				title="Mango GIS - Sign in"
				description="Sign in to manage your maps and data."
				canonical="https://mangomap.com/sign-in"
				openGraph={{
					title: "Mango GIS - Sign in",
					description: "Sign in to manage your maps and data.",
					url: "https://mangomap.com/sign-in",
					site_name: "Mango GIS",
				}}
			/>
			<SignIn />
		</>
	);
};

export default SignInPage;
